import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const HAS_TZ = /(Z|[+-]\d{2}:?\d{2})$/;
const MADRID_FMT = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});

// Date + HH:MM in Madrid time. Naive ISO strings are already Madrid local.
export function madridParts(iso) {
  if (!iso) return null;
  if (!HAS_TZ.test(iso)) {
    const m = iso.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/);
    return m ? { date: m[1], time: m[2] } : null;
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const p = Object.fromEntries(MADRID_FMT.formatToParts(d).map(x => [x.type, x.value]));
  return { date: `${p.year}-${p.month}-${p.day}`, time: `${p.hour}:${p.minute}` };
}

export const madridTime = (iso, fallback = '--:--') => madridParts(iso)?.time || fallback;

export const madridLocalInput = (iso) => {
  const p = madridParts(iso);
  return p ? `${p.date}T${p.time}` : '';
};
